function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4e96c6ab\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./unimicroCredentialsModal.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./unimicroCredentialsModal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4e96c6ab\",\"hasScoped\":false}!./unimicroCredentialsModal.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/unimicroCredentialsModal/unimicroCredentialsModal.vue
// module id = 2742
// module chunks = 1